import DadataSuggest from './DadataSuggest';
import withDadata from './withDadata';


export default DadataSuggest;
export {
	DadataSuggest,
	withDadata,
};
